<nav id="mainSidebar" class="sidebar">
    <ul class="list-unstyled components">
        <li>
            <a class="" routerLink="/app/search" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <i class="fa cfa cfa-search"></i>
                <span>Recherche</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/city" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <i class="fa cfa cfa-home"></i>
                <span>Mes secteurs</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/tools/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <i class="fa cfa cfa-graph"></i>
                <span>Nos outils</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/favorites" routerLinkActive="active">
                <i class="fa cfa cfa-heart"></i>
                <span>Mes favoris</span>
            </a>
        </li>
        <li *ngIf="showHistoric"
            [stepContent]="showHistoricStepContent"
            joyrideStep="showHistoricStep">
            <a class="hide-mobile" routerLink="/app/historic" routerLinkActive="active">
                <i class="fa cfa cfa-history"></i>
                <span>Mon historique</span>
            </a>
        </li>
        <li class="minimize isMinimizable">
            <a class="mb-2 cta_min">
                <i class="fa cfa cfa-findeparcours"></i>
                <span>Aller plus loin
                    <img class="down" src="assets/icons/down.svg" />
                </span>
            </a>
            <ul>
                <li><a href="https://tally.so/r/mRPzQ4?utm_source=app" target="_blank">Investissement clé en main</a></li>
<!--                <li><a href="">Formation immobilière</a></li>-->
                <li><a href="https://meet.brevo.com/thomas-cornu/coaching-immobilier" target="_blank">Coaching immobilier</a></li>
                <li><a href="https://chat.whatsapp.com/GcaODSL9hGf8LpfG7F7Ws5" target="_blank">Groupe privé</a></li>
                <li><a routerLink="/app/partners" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" href="">Partenaires</a></li>
            </ul>
        </li>
<!--        <li>-->
<!--            <a class="offre-bf hide-mobile" href="https://g07t4ye8.sibpages.com/">-->
<!--                <i class="fa cfa cfa-clock-o"></i>-->
<!--                <span>Offre black Friday</span>-->
<!--            </a>-->
<!--        </li>-->
    </ul>

    <a class="text-center collapseBtn hide-mobile">
        <i class="fa fa-angle-left"></i>
        <i class="fa fa-angle-right"></i>
    </a>
</nav>

<!-- Onboarding -->
<ng-template #showHistoricStepContent>
    <div class="user_onboarding_content">
        <h2>Mon historique</h2>
        <p>
            Vous avez trouvé une super annonce, mais vous ne l’avez pas enregistrée en favoris ?<br/>
            <br/>
            Pas de panique ! Retrouvez ici l’historique des dernières annonces ouvertes.
        </p>
    </div>
</ng-template>
